import { render } from "./BestSellersSlick.vue?vue&type=template&id=3780518f"
import script from "./BestSellersSlick.vue?vue&type=script&lang=js"
export * from "./BestSellersSlick.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/BestSellersSlick.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3780518f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3780518f', __exports__)) {
    api.reload('3780518f', __exports__)
  }
  
  module.hot.accept("./BestSellersSlick.vue?vue&type=template&id=3780518f", () => {
    api.rerender('3780518f', render)
  })

}


export default __exports__